import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		...shorthands.padding("20px"),
		fontSize: tokens.fontSizeBase200,
		maxWidth: "304px",
	},
	descriptionAndQueueName: {
		...ellipsis(),
	},
	descriptionType: {
		whiteSpace: "nowrap",
	},
	itemDebuggingId: {
		marginRight: "10px",
		whiteSpace: "nowrap",
	},
	skillsList: {
		color: tokens.colorNeutralForeground3,
	},
	skillsText: {
		textAlign: "start",
	},
	row: {
		marginBottom: "4px",
	},
});
